/** TanStack Query keys for the WhatsApp feature. */
export const whatsappKeys = {
  accounts: ['whatsapp', 'accounts'] as const,
  chats: (accountId: string) => ['whatsapp', 'chats', accountId] as const,
  messages: (accountId: string, chatJid: string) =>
    ['whatsapp', 'messages', accountId, chatJid] as const,
};
